// extracted by mini-css-extract-plugin
export default {"commentListSpace":"CommentsModal_commentListSpace__sJ0iB","titleDiv":"CommentsModal_titleDiv__Rk+VH","draggableModalWrap":"CommentsModal_draggableModalWrap__GWYhJ"};